var _ = require('lodash');

export default class JobsFilters {
    filterableFieldsWithType = {
        name: 'string',
        city_id: 'number',
        job_opening_category_child_id: 'number',
        of_type: 'array',
        published_since: 'array',
        of_experience_level: 'array',
        of_salary: 'string',
        with_tags: 'array',
        sort: 'string',
        per_page: 'string',
    };

    constructor() {
        this.queryParams = window.currentQueries;
        this.setCsrfToken();
        this.setupListeners();
        this.applyFiltersFromQueryString();
    }

    setCsrfToken() {
        this.csrfToken = (document.querySelector('input[name="_token"]')).value;
    }

    setupListeners() {
        const that = this;
        async function onChange(e) {
            if ($(e.target).attr('data-search-form') === '') {
                e.preventDefault();
                return;
            }

            if ($(e.target).attr('id') === 'bookmarks') {
                e.preventDefault();
                return;
            }
            $('[name="page"]').val(1);

            await that.applyFilters();
        }

        $('input,select').on('change', _.debounce(onChange, 100));

        $('#job-search-form').on('submit', e => {
            e.preventDefault();
            that.applyFilters().then();
            $('[name="page"]').val(1);

        });

        $('body').on('click', '[data-filter-name]',e => {
            const filterName = $(e.target).attr('data-filter-name');
            const filterValue = $(e.target).attr('data-filter-value');
            switch (filterName) {
                case 'city_autocomplete':
                    $(`[name^="city_id"]`).val('')
                    $(`[name^="city_autocomplete"]`).val('')
                    break;
                case 'job_opening_category_child':
                    $(`[name^="job_opening_category_child_id"]`).val('').trigger('chosen:updated');
                    $(`[name^="job_opening_category_child"]`).val('')
                    break;
                case 'name':
                    $('#name').val('')
                    break;
                case 'of_experience_level':
                    $(`[name^="of_experience_level"][value="all"]`).prop('checked', true);
                    break;
                case 'of_type':
                    $(`[name^="of_type"][value="all"]`).prop('checked', true);
                    break;
                case 'of_salary':
                    $(`[name^="of_salary"]`).val('Toate salariile');
                    $('.salary-range-slider').slider('value', 0).trigger('change');
                    $('.amount-all').removeClass('d-none');
                    $('.salary-amount').addClass('d-none');
                    break;
                case 'published_since':
                    $(`[name^="published_since"][value="all"]`).prop('checked', true);
                    break;
                case 'with_tags':
                    $(`[name^="with_tags"][value="${filterValue}"]`).prop('checked', false)
                    break;
            }

            $(e.target).parent('li').remove();

            if ($('#applied-filters').find('ul').children(':not(#reset-filters)').length === 0) {
                $('#applied-filters').hide();
            }

            $('[name="page"]').val(1);

            this.applyFilters().then();
        });

        $('#reset-filters').on('click', e => {
            e.preventDefault();
            this.resetFilters();
        });

        $('body').on('click', '.ls-pagination > ul > li > a', e => {
            e.preventDefault();
            $('[name="page"]').val($(e.target).attr('data-page') || 1);
            this.applyFilters().then();
        });
    }

    resetFilters(filterName, skipApply) {
        if (typeof filterName === 'undefined') {
            $(`[name^="city_id"]`).val('')
            $(`[name^="city_autocomplete"]`).val('')
            $(`[name^="job_opening_category_child_id"]`).val('').trigger('chosen:updated');
            $(`[name^="job_opening_category_child"]`).val('')
            $('#name').val('')
            $(`[name^="of_experience_level"][value="all"]`).prop('checked', true);
            $(`[name^="of_type"][value="all"]`).prop('checked', true);
            $(`[name^="of_salary"]`).val('Toate salariile');
            $('.salary-range-slider').slider('value', 0).trigger('change');
            $('.amount-all').removeClass('d-none');
            $('.salary-amount').addClass('d-none');
            $(`[name^="published_since"][value="all"]`).prop('checked', true);
            $(`[name^="with_tags"]:checked`).prop('checked', false)
        }

        switch (filterName) {
            case 'city_autocomplete':
                $(`[name^="city_id"]`).val('')
                $(`[name^="city_autocomplete"]`).val('')
                break;
            case 'job_opening_category_child':
                $(`[name^="job_opening_category_child_id"]`).val('').trigger('chosen:updated');
                $(`[name^="job_opening_category_child"]`).val('')
                break;
            case 'name':
                $('#name').val('')
                break;
            case 'of_experience_level':
                $(`[name^="of_experience_level"][value="all"]`).prop('checked', true);
                break;
            case 'of_type':
                $(`[name^="of_type"][value="all"]`).prop('checked', true);
                break;
            case 'of_salary':
                $(`[name^="of_salary"]`).val('Toate salariile');
                $('.salary-range-slider').slider('value', 0).trigger('change');
                $('.amount-all').removeClass('d-none');
                $('.salary-amount').addClass('d-none');
                break;
            case 'published_since':
                $(`[name^="published_since"][value="all"]`).prop('checked', true);
                break;
            case 'with_tags':
                $(`[name^="with_tags"][value="${filterValue}"]`).prop('checked', false)
                break;
        }

        if (! skipApply) {
            this.applyFilters().then();
        }
    }

    readFilters() {
        const filters = {};
        for (const field in this.filterableFieldsWithType) {
            const fieldType = this.filterableFieldsWithType[field];
            const input = $(`[name^="${field}"]`);

            if (input.length === 0) {
                continue;
            }

            const inputType = $(input).attr('type') || $(input).prop('tagName').toLowerCase();

            let inputValue = null;

            switch (inputType) {
                case 'text':
                case 'hidden':
                case 'select':
                    inputValue = $(input).val();
                    break;
                case 'radio':
                    inputValue = $(`[name^="${field}"]:checked`).val();
                    break;
                case 'checkbox':
                    inputValue = $(`[name^="${field}"]:checked`).map((index, item) => {
                        return $(item).val()
                    }).toArray();
                    break;
            }

            filters[field] = inputValue;
        }

        for (let filter in filters) {
            if (filters[filter] === null || filters[filter] === undefined || filters[filter] === '') {
                delete filters[filter];
            }
        }

        if (filters['of_salary'] === 'Toate salariile') {
            delete filters['of_salary'];
        }

        filters['page'] = $('[name="page"]').val() || 1;

        return filters;
    }

    async findJobs(ids) {
        const filterPayload = {'_token': this.csrfToken};

        filterPayload['filter[id]'] = ids;

        const jobs = await $.post('/', filterPayload);

        $('#pagination-info').html(jobs.paginationInfo);
        $('#jobs-container').html(jobs.view);

        $(".chosen-select").chosen({
            disable_search_threshold: 10,
            width:'100%',
        });

        window.dispatchEvent(
            new Event('jobs-loaded')
        );
    }

    async applyFilters() {
        const currentlyAppliedFilters = this.readFilters();
        const transformedFilters = this.transformFiltersForSearch(currentlyAppliedFilters);
        const filterPayload = transformedFilters;
        filterPayload['_token'] = this.csrfToken;

        const jobs = await $.post('/', filterPayload);

        $('#pagination-info').html(jobs.paginationInfo);
        $('#jobs-container').html(jobs.view);

        $(".chosen-select").chosen({
            disable_search_threshold: 10,
            width:'100%',
        });

        if ($('#job_opening_category_child_id').val() !== '') {
            currentlyAppliedFilters['job_opening_category_child'] = $('#job_opening_category_child_id option:selected').html();
        }

        if ($('#city_id').val() !== '') {
            currentlyAppliedFilters['city_autocomplete'] = $('#city_autocomplete').val();
        }

        this.displayAppliedFilters(currentlyAppliedFilters);
        this.updateQueryString(transformedFilters);

        window.dispatchEvent(
            new Event('jobs-loaded')
        );

        $('#bookmarks').prop('checked', false)
            .change();
    }

    updateQueryString(filters) {
        let url = new URL(window.location.origin);
        let searchParams = url.searchParams;

        const exceptFilters = ['_token'];

        for (let filter in filters) {
            if (typeof filters[filter] === 'undefined') {
                continue;
            }

            if (exceptFilters.includes(filter)) {
                continue;
            }

            if (Array.isArray(filters[filter]) && filters[filter].length === 0) {
                continue;
            }

            searchParams.set(filter, filters[filter]);
        }

        url.search = searchParams.toString();

        let newUrl = url.toString();

        window.history.replaceState(null, null, newUrl);
    }

    displayAppliedFilters(filters) {
        const skipFilters = ['city_id', 'sort', 'page', 'per_page', 'job_opening_category_child_id'];
        const filterElements = [];
        const template = `<li>
    <input type="checkbox" id="applied-filter-ID-NAME" name="applied_filters[]" data-filter-name="ID" data-filter-value="NAME" checked="checked" />
    <label for="applied-filter-ID-NAME">NAME &nbsp; &times;</label>
</li>`;

        for (const filterName in filters) {
            let filter = filters[filterName];

            if (filterName === 'with_tags' && ! Array.isArray(filter)) {
                filter = filter.split(',');
            }

            if (filter === 'all') {
                continue;
            }

            if (skipFilters.includes(filterName)) {
                continue;
            }

            if (typeof filter === 'undefined') {
                continue;
            }

            if (Array.isArray(filter) && filter.length === 0) {
                continue;
            }

            if (Array.isArray(filter)) {
                for (const item of filter) {
                    filterElements.push(
                        template.replaceAll('ID', filterName)
                            .replaceAll('NAME', item)
                    );
                }
                continue;
            }

            filterElements.push(
                template.replaceAll('ID', filterName)
                    .replaceAll('NAME', filter)
            );
        }

        if (filterElements.length > 0) {
            $('#applied-filters').find('ul > li:not(#reset-filters)').remove();
            $('#applied-filters').find('ul').prepend(filterElements);
            $('#applied-filters').show();
        } else {
            $('#applied-filters').hide();
        }
    }

    transformFiltersForSearch(filters) {
        const filterableFields = [
            'name',
            'city_id',
            'job_opening_category_child_id',
            'of_type',
            'published_since',
            'of_experience_level',
            'of_salary',
            'with_tags',
        ];
        const transformedFilters = {};

        for (let filter in filters) {
            if (! filterableFields.includes(filter)) {
                continue;
            }

            const filterName = filter.replaceAll('[]', '');
            transformedFilters[`filter[${filterName}]`] = filters[filter];
        }

        console.log(filters);

        transformedFilters['sort'] = filters['sort'];
        transformedFilters['page'] = filters['page'] ?? 1;
        transformedFilters['per_page'] = filters['per_page'];
        transformedFilters['name'] = filters['name'];

        return transformedFilters;
    }

    applyFiltersFromQueryString() {
        for (const query in this.queryParams) {
            const name = query;
            const value = this.queryParams[name];

            if (name === 'job_opening_category_child') {
                continue;
            }

            let input = $(`[name^="${name}"]`);

            if (input.length > 1) {
                if ($(input).attr('type') === 'checkbox') {
                    const values = value.split(',');

                    const queryBits = [];

                    for (const value of values) {
                        queryBits.push(`[name^="${name}"][value="${value}"]`)
                    }

                    input = $(queryBits.join(','));
                } else {
                    input = $(`[name^="${name}"][value="${value}"]`);
                }
            }

            switch ($(input).attr('type') || $(input).prop('tagName').toLowerCase()) {
                case 'text':
                case 'hidden':
                    $(input).val(value);
                    if (name === 'of_salary') {
                        for (let salaryValue in salaryRanges) {
                            if (salaryRanges[salaryValue].label === value) {
                                $('.salary-range-slider').slider('value', salaryValue);
                            }
                        }
                    }

                    break;
                case 'radio':
                case 'checkbox':
                    $(input).prop('checked', true);
                    break;
                case 'select':
                    $(input).val(value)
                        .trigger('chosen:updated')
                        .change()
                        .trigger('change');
                    break;
            }
        }

        const salarySliderValue = $('.salary-range-slider').slider('value');
        $( ".salary-amount .min" ).text( salaryRanges[salarySliderValue].min );
        $( ".salary-amount .max" ).text( salaryRanges[salarySliderValue].max );

        this.displayAppliedFilters(this.queryParams);
    }
}
